import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { ContentProvider } from './data';
import Preloader from './components/Preloader';
import PromoManager from './components/PromoManager';
import HomePage from './pages/HomePage';
import StructuralPage from './pages/StructuralPage';
import InfrastructurePage from './pages/InfrastructurePage';
import ResearchPage from './pages/ResearchPage';
import NotFound from './pages/NotFound';

// §15: code-split the /admin bundle from the public bundle.
const AdminApp = lazy(() => import('./admin/AdminApp'));

// Themed fallback so there is never a white flash while a chunk loads (§10).
function RouteFallback() {
  return (
    <div
      style={{
        flex: 1,
        display: 'grid',
        placeItems: 'center',
        minHeight: '60vh',
        color: 'var(--text-400)',
        font: 'var(--body)',
      }}
    >
      Loading…
    </div>
  );
}

export default function App() {
  return (
    <ContentProvider>
      <Preloader />
      <BrowserRouter>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
          {/* Public routes (§7) */}
          <Route path="/" element={<HomePage />} />
          <Route path="/structural" element={<StructuralPage />} />
          <Route path="/infrastructure" element={<InfrastructurePage />} />
          <Route path="/research" element={<ResearchPage />} />

          {/* Protected admin (§12/§13) — guard lives inside AdminApp */}
          <Route path="/admin/*" element={<AdminApp />} />

          {/* Styled 404 (§15) */}
          <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <PromoManager />
      </BrowserRouter>
    </ContentProvider>
  );
}
